import React from "react";
import { Info } from "@mui/icons-material";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface HeaderProps {
  title: string;
  onToggleDetails: () => void;
  showDetails: boolean;
}

const PieChartsHeader: React.FC<HeaderProps> = ({ title, onToggleDetails, showDetails }) => {
  const { fontClass, bgClass, borderHighlight } = useUserTheme();

  return (
    <div className="flex items-center justify-between mb-2">
      <h3 className={`text-lg font-semibold ${fontClass}`}>{title}</h3>
      <button
        onClick={onToggleDetails}
        className={`
          inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full transition-all duration-300
          ${showDetails ? `${bgClass} ${borderHighlight}` : `${bgClass} border border-gray-300`}
          ${fontClass}
        `}
        aria-expanded={showDetails}
        aria-label={showDetails ? "Hide details" : "Show details"}
      >
        <Info className="w-3 h-3" />
        <span>{showDetails ? "Hide Details" : "Details"}</span>
      </button>
    </div>
  );
};

export default PieChartsHeader;
